export type ContentState<T> =
  | { status: 'loading' }
  | { status: 'error'; error: unknown }
  | { status: 'empty' }
  | { status: 'ready'; data: T };

export interface ContentStateInput<T> {
  data: T | null | undefined;
  isLoading: boolean;
  error: unknown;
}

/**
 * Resolves the smallest content boundary state without treating refetches as
 * an initial load. Usable data always owns the region, including on error.
 */
export function resolveContentState<T>({
  data,
  isLoading,
  error,
}: ContentStateInput<T>): ContentState<T> {
  if (data !== null && data !== undefined) {
    return { status: 'ready', data };
  }

  if (isLoading) {
    return { status: 'loading' };
  }

  if (error !== null && error !== undefined) {
    return { status: 'error', error };
  }

  return { status: 'empty' };
}
